module.exports = __webpack_public_path__ + "static/media/hiena.afac4bc4.png";